import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";

export const getConversation = (urlData, userToken) => {
  const apiUr = Number(urlData)
    ? `/api/admin/messages/conversations/${urlData}`
    : "/api/agent/messages/conversations";
  return axios.get(apiUr, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const useConversations = (urlData, userToken) => {
  return useQuery({
    queryKey: ["conversation"],
    queryFn: () => getConversation(urlData, userToken),
    // The query will not execute until the id exists
    //  enabled: !!id,
    retry: 10,
  });
};

export const claimConversation = (data) => {
  return axios.post(
    `/api/agent/messages/conversations/${data.id}/claim`,
    null,
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const useClaimConversation = () => {
  return useMutation(claimConversation, {
    onSuccess: (data) => {
      console.log({ data });
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};

export const getMessages = (id, userToken, page) => {
  return axios.get(
    `/api/agent/messages/conversations/${id}/messages?page=${page}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const useMessages = (id, userToken, page) => {
  return useQuery({
    queryKey: ["messages"],
    queryFn: () => getMessages(id, userToken, page),
    enabled: !!id,
  });
};

export const sendMessage = (data) => {
  return axios.post(`/api/agent/messages/`, data.sendData, {
    headers: {
      Authorization: `Bearer ${data.token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const useSendMessage = () => {
  return useMutation(sendMessage, {
    onSuccess: (data) => {
      console.log({ data });
    },
    onError: (error) => {
      console.log({ error });
    },
  });
};

export const getProfileMedia = (data) => {
  return axios.get(
    `/api/images/agent/conversation-images?profile_id=${data.data.fictitious_profile.id}&user_profile_id=${data.data.user_profile.id}`,
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const useProfileMedia = (data) => {
  return useQuery({
    queryKey: ["profileMedia"],
    queryFn: () => getProfileMedia(data),
    // retry: 2,
    // retryDelay: 1000
  });
};

export const getMessageImages = (data) => {
  return axios.get(
    `/api/images/agent/message-images?profile_id=${data.data.fictitious_profile.id}&user_profile_id=${data.data.user_profile.id}`,
    {
      headers: {
        Authorization: `Bearer ${data.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

export const useMessageImage = (data) => {
  return useQuery({
    queryKey: ["messageImage"],
    queryFn: () => getMessageImages(data),
    // retry: 2,
    // retryDelay: 1000
  });
};
